import React from "react";

interface ISidePanelLayoutProps {
  imageUrl: string;
  backgroundColor?: string;
  children?: React.ReactNode;
}

const SidePanelLayout: React.FC<ISidePanelLayoutProps> = ({
  imageUrl,
  backgroundColor,
  children,
}) => {
  const style = backgroundColor
    ? ({ ["--side-panel-bg"]: backgroundColor } as React.CSSProperties)
    : undefined;

  return (
    <div style={style} className="h-screen w-full bg-[var(--surface-default)] md:flex md:items-center md:justify-center md:p-0 lg:p-10 md:bg-[var(--side-panel-bg,var(--primary-100))] md:dark:bg-[var(--background-default-variant)] p-2">
      {/* --img-w = maior imagem 9:16 que cabe e --col-w a coluna que a envolve; o card deriva daí. */}
      {/* O formulario nunca desce de 380px (reCAPTCHA v2 = 304px + paddings), so entao as metades deixam de ser iguais. */}
      <div className="w-full bg-[var(--surface-default)] flex flex-col [--col-w:calc(var(--img-w)_+_36px)] md:[--img-w:min(50vw_-_36px,(100vh_-_48px)*0.5625)] lg:[--img-w:min(50vw_-_56px,514px,(80vh_-_48px)*0.5625)] md:w-[calc(var(--col-w)_+_max(var(--col-w),380px))] md:h-[calc(var(--img-w)*1.77778_+_48px)] md:flex-row md:rounded-2xl md:shadow-[0_20px_60px_-15px_rgba(0,0,0,0.18)] md:dark:shadow-[0_20px_60px_-15px_rgba(0,0,0,0.55)] md:dark:ring-1 md:dark:ring-[var(--surface-default-variant-2)] h-full overflow-hidden">
        <div
          aria-hidden="true"
          className="hidden md:flex md:w-[var(--col-w)] md:shrink-0 md:py-12 md:pl-12 md:pr-6 h-full"
        >
          <img
            src={imageUrl}
            alt=""
            className="w-full aspect-[9/16] h-auto object-cover rounded-2xl shadow-[0_15px_40px_-10px_rgba(0,0,0,0.30)] dark:shadow-[0_15px_40px_-10px_rgba(0,0,0,0.60)]"
            loading="eager"
            decoding="async"
          />
        </div>
        <div className="relative w-full flex flex-col items-stretch md:w-[max(var(--col-w),380px)] md:shrink-0 md:py-8 md:px-6 lg:py-10 lg:px-10 overflow-y-auto overflow-x-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SidePanelLayout;